import { useQuery } from "react-query";
import axiosBaseConfig from "../../../configs/axios/axios-base.config";

export const useGetRubbishDynamicPrices = (rubbishId, location) => {
	return useQuery(["rubbishDynamicPrices", rubbishId], () => {
		return axiosBaseConfig.put(`shared/dynamicPriceV3`, { location }).then((res) => res.data);
	});
};
